//Created by wangshuyi on 07/03/2018.

'use strict';
import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: navigator.language, //'zh-TW'
  fallbackLocale: 'zh-CN',
  silentTranslationWarn: true,
  messages:{}
});

export default i18n;
